import { render, staticRenderFns } from "./ForestersCanadaCE-EN.vue?vue&type=template&id=74491b9f&scoped=true"
import script from "./ForestersCanadaCE-EN.vue?vue&type=script&lang=js"
export * from "./ForestersCanadaCE-EN.vue?vue&type=script&lang=js"
import style0 from "./ForestersCanadaCE-EN.vue?vue&type=style&index=0&id=74491b9f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74491b9f",
  null
  
)

export default component.exports